<!-- /resources/js/Components/Candidate/Career/CandidateCareerPage.vue -->
<template>
  <div class="content-wrapper p-0">
    <div v-if="!checkCondition(careerPage)" class="hero position-relative pt-5">
      <div class="hero__item--content container">
        <div class="d-flex justify-content-end mb-3">
          <a :href="urlGenerator(loggedIn ? 'admin/dashboard' : 'admin/users/login')"
             class="btn btn-primary">{{ $t(loggedIn ? 'dashboard' : 'login') }}</a>
        </div>
      </div>
    </div>

    <hero
        ref="hero"
        v-else
        :is-candidate="isCandidate"
        :cover="jobPostCover"
        :icon="icon"
        :logged-in="loggedIn"
        :logo="logo"
        :pageSettingContent="careerPage.job_post_settings.content.bodySection"
        :body-section="careerPage.job_post_settings.content.bodySection"
        :active-preview="activePreview"
    />

    <div id="vueperSlideText">
      <vueper-slides :dragging-distance="70">
        <vueper-slide
            v-for="(slide, i) in slides"
            :key="i"
            :image="slide.image"
            :title="$t(slide.SliderTitle)"
            :content="$t(slide.SliderContent)"
        />
      </vueper-slides>
    </div>

    <div class="editor-content">
      <div class="preview-content career-page" style=" padding-top: 0 !important;">
        <div class="preview container">
          <template
              v-if="!(careerPage && careerPage.job_post_settings && careerPage.job_post_settings.content && careerPage.job_post_settings.content.hero)">
            <div v-if="pageBlocks[pageView].logo" class="d-flex flex-column align-items-center mb-5">
              <img :src="icon" alt="" class="candidate-viewable-icon img-fluid" />
            </div>
          </template>

          <br><br>
          <div id="jobs" class="mt-5">
            <h5 :style="`font-size: ${headingsStyle.fontSize}; font-weight: ${headingsStyle.fontWeight}; letter-spacing: ${headingsStyle.letterSpacing}; color: ${headingsStyle.color};`"
                class="job-section-heading">
              <template v-if="!jobsLoading">
                {{ $t('latest_jobs') }}
              </template>
            </h5>

            <div class="job-openings">
              <app-pre-loader v-if="jobsLoading" />
              <div class="row" v-else>
                <div
                    v-for="(job, index) in jobList"
                    :key="job.slug || index"
                    :class="{ 'col-md-4 col-xl-4': (activePreview === 'desktop') }"
                    class="col-12 mb-primary"
                >
                  <JobOpeningCard :job="job" />
                </div>
                <div class="col-12" v-if="newJobsLoading">
                  <app-pre-loader />
                </div>
              </div>
            </div>
          </div>

          <div class="astrodivider"><div class="astrodividermask"></div><span><i>&#10038;</i></span></div>

          <!-- Footer -->
          <div class="container py-4">
            <div class="row gy-4 gx-5">
              <div class="col-lg-4 col-md-6">
                <h5 class="h1" style="color: rgb(15, 55, 218);font-weight: bolder;">DE-VISA International</h5>
                <p class="small text-muted mb-0">{{ companyText }}</p>
              </div>

              <div class="col-lg-2 col-md-6">
                <h5 class="mb-3" style="color: rgb(15, 55, 218);">{{$t('important_links')}}</h5>
                <ul class="list-unstyled text-muted">
                  <li><a href="#">KMK</a></li>
                  <li><a href="#">Goethe-Institut</a></li>
                  <li><a href="#">{{$t('Jobsuche')}}</a></li>
                </ul>
              </div>

              <div class="col-lg-2 col-md-6">
                <h5 class="mb-3" style="color: rgb(15, 55, 218);" >{{$t('our_services')}}</h5>
                <ul class="list-unstyled text-muted">
                  <li><a href="#">{{$t('home')}}</a></li>
                  <li><a href="#" @click.prevent="showModal('imprint')">{{$t('imprint')}}</a></li>
                  <li><a href="#" @click.prevent="showModal('privacy_policy')">{{$t('privacy_policy')}}</a></li>
                </ul>
              </div>

              <!-- Replaced Newsletter with Social Media -->
              <div class="col-lg-4 col-md-6">
                <h5 class="mb-3" style="color: rgb(15, 55, 218);">{{$t('follow_us')}}</h5>
                <p class="small text-muted">{{$t('follow_us_text') || 'Connect with us on social media.'}}</p>

                <ul class="list-inline m-0">
                  <li class="list-inline-item me-2 mb-2">
                    <a
                        :href="socialLinks.linkedin"
                        class="btn btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        title="LinkedIn"
                    >
                      <i class="fab fa-linkedin-in" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="list-inline-item me-2 mb-2">
                    <a
                        :href="socialLinks.facebook"
                        class="btn btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                        title="Facebook"
                    >
                      <i class="fab fa-facebook-f" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="list-inline-item mb-2">
                    <a
                        :href="socialLinks.instagram"
                        class="btn btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        title="Instagram"
                    >
                      <i class="fab fa-instagram" aria-hidden="true"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <!-- /Social Media -->
            </div>
          </div>
          <!-- /Footer -->
        </div>
      </div>
    </div>

    <simple-modal
        v-if="showLegalModal"
        :title="$t(activeLegalModal)"
        :content="$t(`${activeLegalModal}_content`)"
        @close="closeModal"
    />
  </div>
</template>

<script>
import { axiosGet, urlGenerator } from "../../../Helpers/AxiosHelper";
import { PUBLIC_JOB_POST, JOB_LIST } from "../../../Config/ApiUrl";
import Hero from "../../Helpers/Editor/Hero";
import JobOpeningCard from "../../Helpers/Editor/JobOpeningCard";
import Search from "../../Helpers/Editor/Search";
import { textTruncate } from "../../../Helpers/TextHelper";
import HeroDropdown from "./HeroDropdown.vue";
import { TENANT_BASE_URL } from "../../../Config/UrlHelper";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import AppFunction from "../../../../core/helpers/app/AppFunction";
import SimpleModal from '../../../Components/Helpers/Modal/SimpleModal';

export default {
  name: 'CandidateCareerPage',
  components: { Hero, JobOpeningCard, Search, HeroDropdown, VueperSlides, VueperSlide, SimpleModal },
  props: {
    careerPage: {},
    loggedIn: { type: Boolean, default: false },
    isCandidate: { type: Boolean, required: true }
  },
  filters: {
    truncate(value) {
      const limit = 40;
      if (!value) return '';
      return value.length < limit ? value : value.substring(0, limit) + '...'
    }
  },
  data() {
    return {
      urlGenerator,
      searchTerm: '',
      textTruncate,
      viewType: 'desktop',
      activePreview: 'desktop',
      showAboutUsModal: false,
      year: moment(moment.now()).format("YYYY"),
      jobsLoading: false,
      jobPosts: [],
      nextPageUrl: '',
      totalJobs: null,
      newJobsLoading: false,
      showLegalModal: false,
      activeLegalModal: '',
      legalContent: '',
      slides: [
        {
          SliderTitle: 'SliderTitle1',
          SliderContent: 'SliderContent1',
          image: urlGenerator(`${TENANT_BASE_URL}/images/slider1.jpg`)
        },
        {
          SliderTitle: 'SliderTitle2',
          SliderContent: 'SliderContent2',
          image: urlGenerator(`${TENANT_BASE_URL}/images/slider2.jpg`)
        },
        {
          SliderTitle: 'SliderTitle3',
          SliderContent: 'SliderContent3',
          image: urlGenerator(`${TENANT_BASE_URL}/images/slider3.jpg`)
        },
      ],
      // Placeholder URLs: replace later
      socialLinks: {
        linkedin: '#',
        facebook: '#',
        instagram: 'https://www.instagram.com/devisa.international/',
      }
    }
  },
  computed: {
    jobList() {
      const isOthers = (s) => typeof s === 'string' && s.trim().toLowerCase() === 'others';
      const sorted = this.jobPosts
          .slice()
          .sort((a, b) => (isOthers(a?.name) ? 1 : 0) - (isOthers(b?.name) ? 1 : 0));
      return sorted.map(item => ({
        ...item,
        title: item.name,
        type: item['job_type']?.name,
        location: item['location']?.address,
        department: item['department'] ? item['department'].name : '',
        url: urlGenerator(`${TENANT_BASE_URL}/${item.slug}`),
      }));
    },
    careerPageData() {
      let data = (typeof this.careerPage === 'string') ? JSON.parse(this.careerPage) : this.careerPage;
      return data.job_post_settings ? data.job_post_settings : data;
    },
    content() { return this.careerPageData.content; },
    pageStyle() { return this.careerPageData.pageStyle; },
    pageBlocks() { return this.careerPageData.pageBlocks ? this.careerPageData.pageBlocks : null; },
    pageView() { return this.activePreview === 'desktop' ? 'defaultView' : 'mobileView' },
    titleStyle() { return this.pageStyle[this.pageView].find(item => item.key === 'title') },
    subTitleStyle() { return this.pageStyle[this.pageView].find(item => item.key === 'sub-title') },
    detailsStyle() { return this.pageStyle[this.pageView].find(item => item.key === 'details') },
    headingsStyle() { return this.pageStyle[this.pageView].find(item => item.key === 'headings') },
    descriptionStyle() { return this.pageStyle[this.pageView].find(item => item.key === 'description') },
    icon() { return this.careerPageData.icon ? this.careerPageData.icon : urlGenerator(window.settings.company_icon) },
    logo() { return urlGenerator(window.settings.company_logo); },
    jobPostCover() { return urlGenerator(window.settings.job_post_cover); },
    companyText() {
      return `${this.$t('copyright_text') + ' ' + this.year + ' ' + this.$t('by') + ' '} ${window.settings?.company_name ? window.settings.company_name : ''}`;
    }
  },
  watch: {
    viewType: {
      handler(type) { this.toggleResponsivePreview(type) },
      immediate: true
    }
  },
  mounted() {
    this.checkViewType();
    window.onresize = () => { this.checkViewType(); }
    this.fetchJobs()
    document.body.addEventListener('scroll', this.handleScroll)
  },
  unmounted() {
    document.body.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    fetchJobs() {
      this.jobsLoading = true
      axiosGet(JOB_LIST + '?per_page=' + 10)
          .then(response => {
            this.jobPosts = response?.data?.data
            this.nextPageUrl = response.data.next_page_url
            this.totalJobs = response?.data?.total
          })
          .catch(e => console.dir(e))
          .finally(() => this.jobsLoading = false)
    },
    searchJobs(searchTerm) {
      this.jobsLoading = true
      axiosGet(JOB_LIST + '?search=' + searchTerm)
          .then(response => {
            this.jobPosts = response?.data?.data
            this.totalJobs = response?.data?.total
          })
          .catch(e => console.dir(e))
          .finally(() => this.jobsLoading = false)
    },
    fetchNewJobs() {
      if (!this.nextPageUrl) return;
      this.newJobsLoading = true
      axiosGet(this.nextPageUrl + '&per_page=' + 10)
          .then(response => {
            this.jobPosts = [...this.jobPosts, ...response?.data?.data]
            this.nextPageUrl = response?.data?.next_page_url;
          })
          .catch(e => console.dir(e))
          .finally(() => this.newJobsLoading = false)
    },
    toggleModal() { this.$refs.hero.toggleModal(); },
    handleReadMoreBtnClick() { this.showAboutUsModal = true; },
    checkCondition(careerPage) { return careerPage?.job_post_settings?.content?.hero; },
    checkViewType() { this.viewType = window.innerWidth > 575 ? 'desktop' : 'mobile'; },
    toggleResponsivePreview(previewType) {
      let preview = $('.preview-content .preview')
      if (previewType === 'desktop') {
        this.activePreview = 'desktop';
        preview.removeClass('mobile-preview').addClass('desktop-preview');
      } else {
        this.activePreview = 'mobile';
        preview.removeClass('desktop-preview').addClass('mobile-preview');
      }
    },
    handleScroll(e) {
      const box = e.target;
      const scrollableHeight = box.scrollHeight - box.clientHeight
      if (box.scrollTop >= scrollableHeight) return this.handleScrollToBottom()
    },
    handleEnterPress(searchTerm) {
      if (!searchTerm) return this.fetchJobs()
      this.searchJobs(searchTerm);
    },
    handleScrollToBottom() {
      if (!this.nextPageUrl) return;
      this.fetchNewJobs();
    },
    showModal(type) {
      this.activeLegalModal = type;
      this.showLegalModal = true;
    },
    closeModal() {
      this.showLegalModal = false;
    }
  }
}
</script>

<style scoped lang="scss">
.hero { padding-bottom: 1rem; }
.font-20 { font-size: 20px; }
.editor-content { margin-top: -4rem; }
.search-wraper- {}

a { color: inherit; text-decoration: none; transition: all 0.3s; }
a:hover, a:focus { text-decoration: none; }

.form-control:focus { background: #212529; }
footer h5 { color: #2850f0; }

.astrodivider { margin:64px auto; width:400px; max-width: 100%; position:relative; }
.astrodividermask { overflow:hidden; height:20px; }
.astrodividermask:after {
  content:''; display:block; margin:-25px auto 0; width:100%; height:25px;
  border-radius:125px / 12px; box-shadow:0 0 8px #2850f0;
}
.astrodivider span {
  width:50px; height:50px; position:absolute; bottom:100%; margin-bottom:-25px;
  left:50%; margin-left:-25px; border-radius:100%; box-shadow:0 2px 4px #4fb39c; background:#fff;
}
.astrodivider i {
  position:absolute; top:4px; bottom:4px; left:4px; right:4px; border-radius:100%;
  border:1px dashed #68beaa; text-align:center; line-height:40px; font-style:normal; color:#2850f0;
}

::v-deep .modal-dialog { width: 70vw; max-width: none !important; margin: 1.75rem auto; }
.legal-content {
  white-space: pre-wrap; font-family: inherit; background: #f8f9fa; padding: 15px;
  border-radius: 5px; max-height: 60vh; overflow-y: auto;
}

/* Social icons */
.btn-icon {
  width: 44px; height: 44px; display: inline-flex; align-items: center; justify-content: center;
  border-radius: 50%; border: 1px solid rgba(0,0,0,.1);
}
.btn-icon:focus { outline: 2px solid rgba(40,80,240,.35); outline-offset: 2px; }
</style>
